export function workOrderTypesOdoo() {
  return [
    { code: 'install', name: 'Installasi' },
    { code: 'maintenance', name: 'Maintenance' },
    { code: 'move', name: 'Pindah Unit' },
  ]
}
